import {createAction, props} from '@ngrx/store';
import {PaginatedInfluencerSso} from '@app/modules/shared/models';

export const InfluencerSsoList = createAction(
  '[Influencer SSO] List',
  (params: any = {}) => params
);
export const InfluencerSsoListSuccess = createAction(
  '[Influencer SSO] List Success',
  props<{paginatedInfluencerSso: PaginatedInfluencerSso}>()
);
export const InfluencerSsoListError = createAction(
  '[Influencer SSO] List Error',
  props<{error: string}>()
);
export const InfluencerSsoCreate = createAction(
  '[Influencer SSO] Create',
  props<{setting: any}>()
);
export const InfluencerSsoCreateSuccess = createAction('[Influencer SSO] Create Success');
export const InfluencerSsoCreateError = createAction(
  '[Influencer SSO] Create Error',
  props<{error: string}>()
);
export const InfluencerSsoUpdate = createAction(
  '[Influencer SSO] Update',
  props<{id: number; setting: any}>()
);
export const InfluencerSsoUpdateSuccess = createAction('[Influencer SSO] Update Success');
export const InfluencerSsoUpdateError = createAction(
  '[Influencer SSO] Update Error',
  props<{error: string}>()
);
export const InfluencerSsoDelete = createAction(
  '[Influencer SSO] Delete',
  props<{id: number}>()
);
export const InfluencerSsoDeleteSuccess = createAction('[Influencer SSO] Delete Success');
export const InfluencerSsoDeleteError = createAction(
  '[Influencer SSO] Delete Error',
  props<{error: string}>()
);
export const ResetInfluencerSsoState = createAction(
  '[Influencer SSO] Reset State',
  (params: any = {}) => params
);
